// @flow

import * as React from 'react';
import styled, { css } from 'styled-components';
import Draggable from 'react-draggable';

// $FlowFixMe
import Dialog from '@material-ui/core/Dialog';
// $FlowFixMe
import DialogContent from '@material-ui/core/DialogContent';
// $FlowFixMe
import Paper from '@material-ui/core/Paper';
// $FlowFixMe
import DialogActions from '@material-ui/core/DialogActions';

import { colors, fontWeight } from '../../constants';
import DefaultTheme from './default_theme';
import XIcon from '../../icons/xicon';
import { SectionHeader } from '../../typography';

export type ModalProps = {
  open: boolean,
  closeModal: Function,
  title: string,
  fullScreen?: boolean,
  fullWidth?: boolean,
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false,
  width?: string,
  onClose?: Function,
  id?: string,
  modalProps?: Object,
  ariaLabelledBy?: string,
  ariaDescribedBy?: string,
  children?: React.Element<any>,
  displayXIcon?: boolean,
  dividers?: boolean,
  draggable?: boolean,
  disableEnforceFocus?: boolean,
  modalBodyOverflow?: string,
};

// $FlowFixMe
export function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const TitleSection = (props) => {
  const { title, closeModal, displayXIcon, draggable } = props;
  return (
    <StyledTitleSection
      className="title-section"
      style={{ cursor: draggable ? 'move' : 'auto' }}
    >
      <ModalTitle id="modal_title">{title}</ModalTitle>
      {displayXIcon && <CloseIcon onClick={closeModal} />}
    </StyledTitleSection>
  );
};

export const ModalContainer = (props: any) => {
  const {
    children,
    open,
    closeModal,
    title,
    displayXIcon,
    fullScreen,
    fullWidth,
    maxWidth,
    width,
    onClose,
    modalProps,
    id,
    ariaLabelledBy,
    ariaDescribedBy,
    className,
    draggable,
    disableEnforceFocus,
  } = props;

  if (fullScreen) {
    console.warn(
      'FULL SCREEN MODAL - Please do not use this modal yet. The design/styling of the full screen modal is still in progress.'
    );
  }
  return (
    <DefaultTheme>
      <StyledDialog
        open={open}
        onClose={closeModal}
        onExit={onClose}
        fullScreen={fullScreen}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        width={width}
        className={className}
        id={id}
        aria-labelledby={ariaLabelledBy || 'modal_title'}
        aria-describedby={ariaDescribedBy}
        {...modalProps}
        {...(draggable ? { PaperComponent: PaperComponent } : {})}
        disableEnforceFocus={disableEnforceFocus}
      >
        <TitleSection
          title={title}
          closeModal={closeModal}
          displayXIcon={displayXIcon}
          draggable={draggable}
        />
        {children}
      </StyledDialog>
    </DefaultTheme>
  );
};

// $FlowFixMe
export const StyledDialogContent = styled((props) => (
  <DialogContent {...props} />
))`
  && {
    padding-top: 20px;
    padding-bottom: 0px;
    padding-left: 20px;
    ${fontWeight('normal')}
    font-size: 14px;

    p {
      font-size: 14px;
    }
    ${({ modalBodyOverflow }) =>
      modalBodyOverflow && `overflow: ${modalBodyOverflow}`};
  }
`;

// $FlowFixMe
export const StyledDialogActions = styled((props) => (
  <DialogActions {...props} />
))`
  &.MuiDialogActions-spacing {
    padding: 20px;
  }
`;

// $FlowFixMe
export const StyledDialog = styled((props) => <Dialog {...props} />)`
  .MuiDialog-paperWidthXs {
    max-width: 300px;
  }
  .MuiDialog-paperWidthSm {
    max-width: 400px;
  }
  .MuiDialog-paperWidthMd {
    max-width: 600px;
  }
  .MuiDialog-paperWidthLg {
    max-width: 800px;
  }
  .MuiDialog-paperWidthXl {
    max-width: 1000px;
  }
  .MuiDialog-paperFullScreen {
    max-width: 100%;
  }
  ${(props) =>
    props.width &&
    css`
      && .MuiDialog-paper {
        max-width: none;
        width: ${props.width};
      }
    `};
`;

export const StyledTitleSection = styled.div`
  position: relative;
  background-color: ${colors.lightestGrey};
`;

export const ModalTitle = styled<{}>(SectionHeader)`
  margin: 15px 0 15px 20px;
`;

export const CloseIcon = styled(XIcon)`
  position: absolute;
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
`;
